import gql from 'graphql-tag'

/* Query que obtiene todos los planes disponibles y los muestra a todos los usuarios en la sección de afiliaciones */
const FETCH_PLANS = gql`
query Plan {
  plans {
    id
    name
    organizer {
      companyName
      profilePicture
    }
  }
}`

/* Query que obtiene todos los planes de un organizador */
const FETCH_USER_PLANS = gql`
query MyPlans {
  myPlans {
    id
    name
    organizer {
      companyName
      profilePicture
    }
    estatus
    affiliations {
      estatus
      expirationDate
      paymentInformation {
        paymentType
      }
      tier{
        name
        amount
        interval
      }
      affiliate {
        name
        lastName
        companyName
        email
        rfc
        tel
      }
      affiliateId
      affiliateData
    }
  }
}`

/* Query que obtiene la información de un plan para mostrarlo en el detalle del plan */
const FETCH_PLAN_DETAILS = gql`
query PlanDetails ($id: String!) {
  planById(id: $id) {
    id
    externalId
    name
    details
    sponsors
    tags
    planImage
    subcategory
    welcomeMessage
    organizer {
        companyName
        profilePicture
    }
    faqs {
        question
        answer
    }
    tiers {
        id
        externalId
        name
        amount
        benefits
        interval
    }
    socialMedia {
        facebook
        twitter
        linkedin
        youtube
    }
    contactDetails {
        email
        tel
        webSite
    }
    extraFields {
      name
      formattedName
      fieldType
      description
      required
      options
    }
  }
}`

export { FETCH_PLANS, FETCH_USER_PLANS, FETCH_PLAN_DETAILS }